// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Other_titleWrapper__NbYHh","menuItem":"Other_menuItem__2Gjvw","chevronRight":"Other_chevronRight__WMOID"};